export default __webpack_public_path__ + "static/lightning_b.ede6e1f6190a168ab3a0fc113af76e8f.svg";